export default "__VITE_ASSET__C3PcGX93__"